module.exports = __webpack_public_path__ + "static/post-five-0d6cd8de4e1032e214adc2e4dd913094.png";